import {ProductService} from "../resource";

const ProductModule = {
	namespaced: true,
	state: {
		datas: [],
		currentPage : 1,
		platformCurrentParams : {
			status: 0,
			mappingStatus: 2,
			currentPage: 1,
		}
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		},
		SET_CURRENT_PAGE(state, data) {
			state.currentPage = data;
		},
		SET_PLATFORM_CURRENT_PARAMS(state, data) {
			state.platformCurrentParams = data;
		}
	},
	actions: {
		createData({ commit, state }, data) {
			return ProductService.ProductCreate(data);
		},

		updateData({ commit, state }, data) {
			return ProductService.ProductUpdate(data.id,data.payload);
		},
		updatePlatformData({ commit, state }, data) {
			return ProductService.ProductPlatformUpdate(data.id,data.payload);
		},

		deleteData({ commit, state }, data) {
			return ProductService.ProductDelete(data);
		},

		async listData({ commit, state }, data) {
			try
			{
				const response = await ProductService.ProductList(data);
				commit("SET_DATA", response.data.Data != null ? response.data.Data : []);
			}
			catch (error)
			{
				console.log(error);
				commit("SET_DATA", []);
			}
		},
		listSku({ commit, state }, data) {
				return ProductService.ProductSkuList(data);
		},
		
		getDetail({ commit, state }, data) {
				return ProductService.ProductDetail(data);
		},
		setCurrentPage({ commit, state }, data){
			commit("SET_CURRENT_PAGE",data)
		},
		setPlatformCurrentParams({ commit, state }, data){
			console.log(data)
			commit("SET_PLATFORM_CURRENT_PARAMS",data)
		}
	},
	getters: {
		getData(state) {
			return state.datas;
		},
		getDataWithAll(state) {
			return  [
				{id:0,name:"--- สินค้าและโปรโมชั่น --- "},...state.datas ];
		},
		getCurrentPage(state) {
			return state.currentPage;
		},
		getPlatformCurrentParams(state) {
			return state.platformCurrentParams;
		}

	},
};

export default ProductModule;